import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json'; // English translations file
import de from '../locales/de.json'; // German translations file
import ar from '../locales/ar.json'; // Arabic translations file

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      ar: { translation: ar }
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
